// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Button from "@insite/mobius/Button";
import { GridContainer, GridItem } from "@insite/mobius/index";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { generateDynamicGridItemStyle } from "@rugby/App/Widgets/DesignSystem/DesignSystem.utils";
import React from "react";

export const XdlToast = () => {
    const toasterContext = React.useContext(ToasterContext);
    const message = `
    Success notification multi-line: Here is an explanation It drops to next line if content is too long.
                Success notification multi-line: Here is an explanation It drops to next line if content is too long.
                Success notification multi-line: Here is an explanation It drops to next line if content is too long.
    `;
    return (
        <GridContainer>
            <GridItem {...generateDynamicGridItemStyle(4, 2)}>
                <Button
                    shape="rounded"
                    color="success"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - Success", body: "Success", messageType: "success" })
                    }
                >
                    Success
                </Button>
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(4, 2)}>
                <Button
                    shape="rounded"
                    color="danger"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - Danger", body: "Danger", messageType: "danger" })
                    }
                >
                    Danger
                </Button>
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(4, 2)}>
                <Button
                    shape="rounded"
                    color="info"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - Info", body: "Info", messageType: "info" })
                    }
                >
                    Info
                </Button>
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(4, 2)}>
                <Button
                    shape="rounded"
                    color="warning"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - Warning", body: "Warning", messageType: "warning" })
                    }
                >
                    Warning
                </Button>
            </GridItem>

            <GridItem {...generateDynamicGridItemStyle(2)}>
                <Button
                    shape="rounded"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - title", body: "Toast Test", messageType: "success" })
                    }
                >
                    Short Message - Toast
                </Button>
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(2)}>
                <Button
                    shape="rounded"
                    variant="secondary"
                    onClick={() =>
                        toasterContext.addToast({ title: "Toast - title", body: message, messageType: "success" })
                    }
                >
                    Long Message - Toast
                </Button>
            </GridItem>
        </GridContainer>
    );
};
